import { GlobalState } from "./types";
import { Layers } from "@/models/map/layers";

export const getLoading = (state: GlobalState): boolean => {
  return state.isLoading;
};

export const getLoggedIn = (state: GlobalState): boolean => {
  return state.isLoggedIn;
};

export const getActiveView = (state: GlobalState): Layers => {
  return state.activeView;
};

